export default __webpack_public_path__ + "static/media/calender.e088c948.svg";